module.exports = __webpack_public_path__ + "jtails-build/img/checkout-fail.f96124e7.svg";